import { technicalLeadershipCourse } from './technical-leadership';
import { systemDesignCourse } from './system-design';
import { apiDevelopmentCourse } from './api-development';
import { testingAutomationCourse } from './testing-automation';
import { agileScrumCourse } from './agile-scrum';
import { complianceDocumentationCourse } from './compliance-documentation';

export const ENTERPRISE_TRAINING_COURSES = [
  technicalLeadershipCourse,
  systemDesignCourse,
  apiDevelopmentCourse,
  testingAutomationCourse,
  agileScrumCourse,
  complianceDocumentationCourse,
];
